/**
 * Defines the submit value for an input component to advise the form component to not send the property of a form input to the server when submitting the form.
 * This enables us to simplify the logic on FormInputs, especially on FormFileInput component, on which it's difficult to display the current value but we want to
 * tell the user that one exists.
 *
 * @type {string}
 */
export const EXISTING_FORM_INPUT_VALUE = '_existing';